module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-couponUse"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('couponUse_title'),
      "url": "/opera/"
    }
  }), _vm._v(" "), (_vm.coupon) ? _c('div', {
    staticClass: "warp"
  }, [_c('div', {
    staticClass: "orderSta clearfix"
  }, [_c('div', {
    staticClass: "Num"
  }, [_vm._v(_vm._s(_vm.$t('couponUse_Num')) + ":\n        "), _c('span', [_vm._v(_vm._s(_vm.coupon.couponNo))])]), _vm._v(" "), _c('div', {
    staticClass: "sta"
  }, [_vm._v(_vm._s(_vm.$t('couponUse_sta')) + ":\n        "), _c('span', [_vm._v(_vm._s(_vm.coupon.sta))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('ul', {
    staticClass: "infoContent twocol"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('couponUse_couponName')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.coupon.couponName))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('couponUse_couponCode')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.coupon.couponCode))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('couponUse_couponTyDes')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.coupon.couponTyDes))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('couponUse_cardNo')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.coupon.cardNo))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.$t('couponUse_couponType')) + ":\n            "), (_vm.coupon.couponType == 'RF') ? _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.coupon.presentValue) + _vm._s(_vm.$t('couponUse_P')))]) : _c('span', {
    staticClass: "infoVal"
  }, [_vm._v("￥" + _vm._s(_vm.coupon.presentValue))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('couponUse_hotelDateSet')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.coupon.hotelDateSet))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('couponUse_validFromDate')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.coupon.validFromDate))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('couponUse_validToDate')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(" " + _vm._s(_vm.coupon.validToDate))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('couponUse_couponDes')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.coupon.couponDes))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('couponUse_remark')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.coupon.remark))])])])])])]) : _vm._e(), _vm._v(" "), _c('nothing', {
    attrs: {
      "condition": _vm.empty,
      "dis": _vm.edis
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "staI"
  }, [_c('div', {
    staticClass: "btn",
    class: {
      p100: !_vm.btnv
    },
    on: {
      "click": _vm.getbarcode
    }
  }, [_vm._v(_vm._s(_vm.$t('couponUse_getbarcode')))]), _vm._v(" "), (_vm.btnv) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.use
    }
  }, [_vm._v(_vm._s(_vm.$t('couponUse_btnv')))]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-58aed8ef","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/CouponUse.vue
// module id = 1791
// module chunks = 107